import { customAgentPermissions, qaAgentPermissions } from "./constants";
import type { AgentAction, AgentPermission, InteractionSite } from "./types";
import { isQaInteractionSite } from "./types";

/**
 * The permission to name when telling a developer which one they lack for an
 * action: the one an admin can grant. A Standard names its own once
 * agent_console_qa_agent_permissions shows it in the permission editor; until
 * then only the Canvas and Data Agents permission can be granted for it.
 * TODO(AIML-5680): name the Standards permission unconditionally once that
 * flipper is on everywhere.
 */
export const grantableAgentPermissionGetter = (
  action: AgentAction,
  interactionSite: InteractionSite | undefined,
  qaAgentPermissionsVisible: boolean
): AgentPermission => {
  if (isQaInteractionSite(interactionSite) && qaAgentPermissionsVisible) {
    return qaAgentPermissions[action];
  }
  return customAgentPermissions[action];
};
